module.exports = __webpack_public_path__ + "static/img/nengli1.80b56e33.png";